import {Capacitor} from "@capacitor/core";

export const config = {
    version:           (<any>import.meta).env.VITE_VERSION,
    firebase_project:  (<any>import.meta).env.VITE_FIREBASE_PROJECT,
    apiUrl:            (<any>import.meta).env.VITE_API_BASE_URL,
    publicUrl:         (<any>import.meta).env.VITE_PUBLIC_BASE_URL,
    debugParams:       (<any>import.meta).env.VITE_DEBUG_PARAMS,
    pusherHost:        (<any>import.meta).env.VITE_PUSHER_HOST,
    isCordova:         (<any>import.meta).env.VITE_IS_CORDOVA === 'true',
    pusherForceTls:    (<any>import.meta).env.MODE !== 'development',
    appEnv:            (<any>import.meta).env.MODE === 'development' ? 'local' : (<any>import.meta).env.MODE, // provide value matching Laravel APP_ENV
    jwtRefreshSeconds: ((<any>import.meta).env.VITE_JWT_REFRESH_MINUTES || 15) * 60,

    clarityProjectId:    ((<any>import.meta).env.VITE_CLARITY_PROJECT_ID || ''),
    bugsnagApiKey:       ((<any>import.meta).env.VITE_BUGSNAG_API_KEY || ''),
    bugsnagReleaseStage: (<any>import.meta).env.MODE,

    featureEnableSignup:      ((<any>import.meta).env.VITE_FEATURE_ENABLE_SIGNUP === 'yes'),
    featureEnableLeagueSetup: ((<any>import.meta).env.VITE_FEATURE_ENABLE_LEAGUE_SETUP === 'yes'),
    featureEnableCourts:      (Capacitor.getPlatform() !== 'ios'),

    isTestMode: (document.cookie?.indexOf('TestMode=yes') >= 0),
    ads:        {
        android: {
            appOpen:      (<any>import.meta).env.VITE_AD_ANDROID_APP_OPEN,
            interstitial: (<any>import.meta).env.VITE_AD_ANDROID_INTERSTITIAL,
            delaySeconds: (<any>import.meta).env.VITE_AD_ANDROID_DELAY_SECONDS,
        },
        ios:     {
            appOpen:      (<any>import.meta).env.VITE_AD_IOS_APP_OPEN,
            interstitial: (<any>import.meta).env.VITE_AD_IOS_INTERSTITIAL,
            delaySeconds: (<any>import.meta).env.VITE_AD_IOS_DELAY_SECONDS,
        },
        test:    {
            appOpen:      (<any>import.meta).env.VITE_AD_TEST_APP_OPEN,
            interstitial: (<any>import.meta).env.VITE_AD_TEST_INTERSTITIAL,
            delaySeconds: (<any>import.meta).env.VITE_AD_TEST_DELAY_SECONDS,
        },
    },
};
